import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import './Styles.css';
import ceLogo from '../../assets/icons/logo-cepune.png';
import loveworldLogo from '../../assets/icons/lwIndia.png';
import chatIcon from '../../assets/icons/kingschat.png';
import lwAppStoreLogo from '../../assets/icons/lw-appstore.png';
import kcConfIcon from '../../assets/icons/Kingsconference.png';
import ceflixLogo from '../../assets/icons/ceflix.png';
import fccIcon from '../../assets/icons/fcc.png';

const Footer = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  const toggleMeetings = (e) => {
    e.preventDefault();
    setShowMeetings(!showMeetings);
  };
  const links = [
    { to: '/',                  label: 'Home' },
    { to: '/foundation-course', label: 'Foundation School' },
    { to: '/fellowships',       label: 'Fellowships' },
    { to: '/about',             label: 'About Us' },
    { to: '/loveworld-singers', label: 'Loveworld Singers' },
    { to: '/social-services',   label: 'Social Services' },
    { to: '/past-services',     label: 'Service Archive' },
    { to: '/#service',          label: 'Service' },
    { to: '/admin/login',       label: 'Admin Portal' },
  ];

  return (
    <footer className="footer">
      <div className="container">

        {/* Main row */}
        <div className="footer-main">

          {/* Left: logos + social icons below */}
          <div className="footer-left">
            <div className="footer-logos">
              <img src={ceLogo}       alt="Christ Embassy Pune" loading="lazy" decoding="async" />
              <img src={loveworldLogo} alt="LoveWorld India"     loading="lazy" decoding="async" />
            </div>
            <div className="footer-social">
              <a href="https://accounts.kingschat.online/log-in?origin=%2F" target="_blank" rel="noopener noreferrer">
                <img src={chatIcon} alt="KingsChat" />
              </a>
              <a href="https://lwappstore.com/" target="_blank" rel="noopener noreferrer">
                <img src={lwAppStoreLogo} alt="Loveworld App Store" />
              </a>
              <a href="https://kingsconference.org/video/home.php" target="_blank" rel="noopener noreferrer">
                <img src={kcConfIcon} alt="Kings Conference" />
              </a>
              <a href="https://lbntv.org/" target="_blank" rel="noopener noreferrer">
                <img src={loveworldLogo} alt="LoveWorld India" />
              </a>
              <a href="https://ceflix.org/" target="_blank" rel="noopener noreferrer">
                <img src={ceflixLogo} alt="CeFlix" />
              </a>
              <div className="meetings-wrapper" style={{ display: 'inline-block', position: 'relative' }}>
                <a href="#" onClick={toggleMeetings} title="Join a Meeting">
                  <img src={fccIcon} alt="FreeConferenceCall" />
                </a>
                {showMeetings && (
                  <div className="meetings-dropdown" style={{ bottom: 'calc(100% + 15px)', top: 'auto', right: 'auto', left: '50%', transform: 'translateX(-50%)' }}>
                    <h4>Join a Meeting</h4>
                    <p className="meetings-help-text">💡 Tip: Please choose the 'Web Version' when joining.</p>
                    <a href="https://join.freeconferencecall.com/ceindiazone2" target="_blank" rel="noopener noreferrer">CE India Zone 2</a>
                    <a href="https://join.freeconferencecall.com/cepune" target="_blank" rel="noopener noreferrer">CE Pune</a>
                    <a href="https://join.freeconferencecall.com/nancymat7" target="_blank" rel="noopener noreferrer">Nancy Mat7</a>
                    <a href="https://join.freeconferencecall.com/cepunechoir5" target="_blank" rel="noopener noreferrer">CE Pune Choir</a>
                    <a href="https://join.freeconferencecall.com/pune-justice" target="_blank" rel="noopener noreferrer">Pune Justice</a>
                  </div>
                )}
              </div>
            </div>
            <div className="footer-contact">
              Contact Us: +918040184671 / +919529607156
            </div>
          </div>

          {/* Right: 2-column nav grid */}
          <nav className="footer-nav" aria-label="Footer navigation">
            {links.map(({ to, label }) => (
              <Link key={to} to={to}>{label}</Link>
            ))}
          </nav>

          {/* App QR Code */}
          <div className="footer-qr" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', marginLeft: 'auto' }}>
            <h4 style={{ color: '#5DB3E8', margin: 0, fontFamily: 'Montserrat, sans-serif', fontSize: '1.1rem' }}>Get Our App</h4>
            <div style={{ background: 'white', padding: '8px', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.3)' }}>
              <QRCodeCanvas value="https://lifeoncanvas.github.io/ChristEmbassyPune?install=true" size={128} level="H" />
            </div>
            <p style={{ margin: 0, fontSize: '0.8rem', color: '#d0d0d0', textAlign: 'center' }}>Scan to Install<br/>(PWA Web App)</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p>
            Copyright © 2026 Christ Embassy &nbsp;|&nbsp; All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
